import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c5907ec8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gas-provider" }
const _hoisted_2 = { class: "is-flex is-align-items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  "data-testid": "transaction-fee"
}
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "is-flex is-align-items-center truncate" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "btn-text" }

import makeBlockie from 'ethereum-blockies-base64'
import { computed, ref, watch } from 'vue'

import Dropdown from '@/popup/components/shared/Dropdown/Dropdown.vue'
import DropdownItem from '@/popup/components/shared/Dropdown/DropdownItem.vue'
import { useAppStore } from '@/popup/store/AppStore'
import Sanitize from '@/popup/components/shared/Sanitize.vue'
import { FrontendProfile } from '@/shared/models/Profile'
import { GasProvider } from '@/shared/models/GasProvider'
import { RelayServiceDBSchema } from '@/shared/Database/UPSettings/models'
import FormattedTokenAmount from '@/popup/components/shared/FormattedTokenAmount.vue'
import { usePreferencesStore } from '@/popup/store/PreferencesStore'
import { ControllerDTO } from '@/business-logic/profile'
import { useProfileStore } from '@/popup/store/ProfileStore'

//TODO: add a current gas provider as ref which allows to add more tests?

type Props = {
  currentProfile: FrontendProfile
  allRelayers: RelayServiceDBSchema[]
  balance: number
  selectedGasProvider?: GasProvider
}

type Emits = {
  (event: 'on-gas-provider-change', value: GasProvider): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GasProvider',
  props: {
    currentProfile: {},
    allRelayers: {},
    balance: {},
    selectedGasProvider: {}
  },
  emits: ["on-gas-provider-change"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit
const appStore = useAppStore()
const preferences = usePreferencesStore()
const profileStore = useProfileStore()

const deviceController = ref<ControllerDTO>()
watch(
  () => profileStore.deviceController,
  async newDeviceController => {
    deviceController.value = newDeviceController
  },
  { immediate: true }
)

const formattedDeviceControllerName = computed(() => {
  const name = deviceController.value?.name
  if (!name) {
    return
  }
  if (name.length > 30) {
    return `${name.slice(0, 29)}...`
  }
  return name
})
const smallIdenticon = computed(() =>
  appStore.upExtensionControllerAddress
    ? makeBlockie(appStore.upExtensionControllerAddress)
    : undefined
)

const onGasProviderChange = async (option: GasProvider) => {
  if (props.selectedGasProvider?.id !== option.id) {
    emits('on-gas-provider-change', option)
  }
}

const selectedOptionLabel = computed(() => {
  if (
    !props.selectedGasProvider ||
    props.selectedGasProvider.type === 'controller'
  ) {
    return
  }

  const defaultRelayer = props.allRelayers.find(
    relayer => relayer.id === props.selectedGasProvider?.id
  )
  return defaultRelayer ? defaultRelayer.name : props.allRelayers[0]?.name
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Dropdown, {
      class: "is-small is-right",
      selected: selectedOptionLabel.value,
      "trigger-class": "ghost-mode p-1"
    }, {
      selected: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          (smallIdenticon.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: smallIdenticon.value,
                class: "profile-identicon mr-2"
              }, null, 8 /* PROPS */, _hoisted_3))
            : _createCommentVNode("v-if", true),
          _createVNode(FormattedTokenAmount, {
            amount: `${_ctx.balance}`,
            decimals: 18,
            symbol: _unref(preferences).token.symbol
          }, {
            default: _withCtx(({ amount, symbol }) => [
              (formattedDeviceControllerName.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(`${formattedDeviceControllerName.value} (${amount} ${symbol})`), 1 /* TEXT */))
                : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('gas_provider.options.controller', {
                  balance: `${amount} ${symbol}`,
                })), 1 /* TEXT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["amount", "symbol"])
        ])
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allRelayers, (relayer) => {
          return (_openBlock(), _createBlock(DropdownItem, {
            key: relayer.id,
            "data-testid": 'test-' + relayer.id,
            "is-active": 
          _ctx.selectedGasProvider?.type === 'relayer' &&
          _ctx.selectedGasProvider?.id === relayer.id
        ,
            onClick: ($event: any) => (onGasProviderChange({ type: 'relayer', id: relayer.id }))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, _toDisplayString(relayer.name), 1 /* TEXT */)
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["data-testid", "is-active", "onClick"]))
        }), 128 /* KEYED_FRAGMENT */)),
        _createVNode(DropdownItem, {
          key: "controller",
          "is-active": _ctx.selectedGasProvider?.type === 'controller',
          disabled: !_unref(appStore).upExtensionControllerAddress,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (
          _unref(appStore).upExtensionControllerAddress
            ? onGasProviderChange({
                type: 'controller',
                id: _unref(appStore).upExtensionControllerAddress,
              })
            : undefined
        ))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["text is-flex is-align-items-center is-justify-content-space-between is-fullwidth", 
            !_unref(appStore).upExtensionControllerAddress ? 'has-text-grey-light' : ''
          ])
            }, [
              _createElementVNode("span", _hoisted_7, [
                (smallIdenticon.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: smallIdenticon.value,
                      class: "profile-identicon mr-2"
                    }, null, 8 /* PROPS */, _hoisted_8))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("span", _hoisted_9, _toDisplayString(deviceController.value?.name ||
              _ctx.$t(
                'profile.create.authorized_apps.browser_extension_display_name'
              )), 1 /* TEXT */)
              ]),
              _createVNode(FormattedTokenAmount, {
                amount: `${_ctx.balance}`,
                decimals: 18,
                symbol: _unref(preferences).token.symbol
              }, {
                default: _withCtx(({ amount, symbol }) => [
                  _createVNode(Sanitize, {
                    class: "is-flex is-align-items-center",
                    html: `<span class='currency-value'>${amount}</span><span class='currency-symbol'>${symbol}</span>`
                  }, null, 8 /* PROPS */, ["html"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["amount", "symbol"])
            ], 2 /* CLASS */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["is-active", "disabled"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["selected"])
  ]))
}
}

})